import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=6c751a1d&"
import script from "./HomeNew.vue?vue&type=script&lang=ts&"
export * from "./HomeNew.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNew.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports